var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDialogClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "vfsyzwsb5a",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1255"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1254"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#vfsyzwsb5a)"
    },
    "data-name": "Group 1222"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4110",
    d: "M20 0A20 20 0 1 1 0 20 20 20 0 0 1 20 0z",
    transform: "translate(15 12)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1253"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3018",
    d: "m-1448.291-616.755-16 16",
    transform: "translate(1491.291 640.755)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3019",
    d: "m-1464.291-616.755 16 16",
    transform: "translate(1491.291 640.755)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 3
    }
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDialogClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-dialogClose.586abc8b25f45b6e6c70781974dd7197.svg";